import Vue from 'vue'
// @ts-ignore
import { StripeElementCard } from '@vue-stripe/vue-stripe'

export default () => {
  Vue.component('StripeElementCard', StripeElementCard)
}
